import axios from 'axios';
import useJwt from '@/auth/jwt/useJwt';

export default {
  namespaced: true,
  state: {
    transactions:[],
    totalTransactions: 0,
    drivers: [],
    totalDrivers: 0,
    limit: 10,
    offset: 0,
    orderField: '',
    driversOrderField: '',
    driverOffset: 0,
    driverLimit: 5,
    searchTerm: '',

    driversList:[],
    totalDriversList: 0,
    driversListOffset: 0,
    driversListLimit: 10,
    driversListOrderField: '',

    updateTableTransactions: false,
    updateTableDrivers: false,
    updateOnUpload: false,

    errorOnLoad: null,

    driverID:"",
    driverName:"",
    driverType:"",
    driverReportDriver: false,
    driverEditMode:"CREATE",

    warningConfirmation: false,
    rowData:{},

    driversForm: []
  },
  mutations: {
    SET_DRIVERS_FORM(state, data){
      state.driversForm = data;
    },
    SET_WARNING_CONFIRMATION(state, data){
        state.warningConfirmation = data
    },
    SET_DRIVER_ID(state, data){
        state.driverID = data
    },
    SET_DRIVER_NAME(state, data){
        state.driverName = data
    },
    SET_DRIVER_TYPE(state, data){
        state.driverType = data
    },
    SET_REPORT_DRIVER(state, data){
        state.driverReportDriver = data
    },
    SET_DRIVER_EDIT_MODE(state, data){
        state.driverEditMode = data
    },
    SET_ROW_DATA(state, data){
      state.rowData = data
    },
    CLEAR_TRANSACTION_DATA(state,data){
      state.rowData={}
    },
    SET_ERROR_ON_LOAD(state, data){
        state.errorOnLoad = data
    },
    SET_UPDATE_TABLE_TRANSACTIONS(state){
        state.updateTableTransactions = !state.updateTableTransactions
    },
    SET_UPDATE_TABLE_DRIVERS(state){
        state.updateTableDrivers = !state.updateTableDrivers
    },
    SET_UPDATE_ON_UPLOAD(state){
        state.updateOnUpload = !state.updateOnUpload
    },
    SET_DRIVERS_LIST(state, data){
        state.driversList = data;
    },
    SET_TOTAL_DRIVERS_LIST(state, data){
        state.totalDriversList = data;
    },
    SET_DRIVERS_LIST_NEXT_PAGE(state, data){
        state.driversListOffset = state.driversListLimit * data - state.driversListLimit < 0 ? 0 : state.driversListLimit * data - state.driversListLimit
    },
    SET_DRIVERS_LIST_PREVIOUS_PAGE(state, data){
        state.driversListOffset = state.driversListLimit * data - state.driversListLimit < 0 ? 0 : state.driversListLimit * data - state.driversListLimit
    },
    SET_DRIVERS_LIST_LIMIT(state, data){
        state.driversListLimit = data;
        state.offset = 0;
    },
    SET_DRIVERS_LIST_ORDER_FIELD(state, data) {
        switch (data.orderType) {
          case 'asc':
            state.driversListOrderField = data.orderField;
            break;
          case 'desc':
            state.driversListOrderField = `-${data.orderField}`;
            break;
          default:
            state.driversListOrderField = null;
            break;
          }
    },
    SET_OFFSET_NEXT(state){
      let newOffset = state.driverOffset + 1
      let maxOffset = state.totalDrivers-state.driverLimit >= 0 ? state.totalDrivers-state.driverLimit : 0;
      state.driverOffset = newOffset >= maxOffset ? maxOffset : newOffset;
    },
    SET_OFFSET_PREVIOUS(state){
      let newOffset = state.driverOffset - 1
      state.driverOffset = newOffset <= 0 ? 0 : newOffset;
    },
    SET_TRANSACTIONS(state, data){
      state.transactions = data;
    },
    SET_TOTAL_DRIVERS(state,data){
      state.totalDrivers = data;
    },
    SET_DRIVERS(state,data){
      state.drivers = data;
    },

    SET_OFFSET(state, data){
        state.offset = data
        state.driverOffset = data
        state.driversListOffset = data;
    },
    SET_NEXT_PAGE(state, data){
      state.offset = state.limit * data - state.limit < 0 ? 0 : state.limit * data - state.limit
    },
    SET_PREVIOUS_PAGE(state, data){
      state.offset =state.limit * data - state.limit < 0 ? 0 : state.limit * data - state.limit
    },
    SET_LIMIT(state, data){
      state.limit = data;
      state.offset = 0;
    },
    SET_TOTAL_TRANSACTIONS(state,data){
      state.totalTransactions = data;
    },

    SET_ORDER_FIELD(state, data) {
        switch (data.orderType) {
          case 'asc':
            state.orderField = data.orderField;
            break;
          case 'desc':
            state.orderField = `-${data.orderField}`;
            break;
          default:
            state.orderField = null;
            break;
          }
      },
    SET_DRIVERS_ORDER_FIELD(state, data) {
        switch (data.orderType) {
          case 'asc':
            state.driversOrderField = data.orderField;
            break;
          case 'desc':
            state.driversOrderField = `-${data.orderField}`;
            break;
          default:
            state.driversOrderField = null;
            break;
          }
    },
    SET_SEARCH_TERM(state, data){
      state.searchTerm = data
    }

  },
  actions: {
    createUpdateTransactionLine({state, commit}, {context, mode, scenario, dimension}){
      let data = {
        transaction_id: state.rowData.ID,
        fields: state.rowData,
        dimension: dimension,
        scenario: scenario
      }

      if(mode=="UPDATE"){
        return context.$http.patch(`${process.env.VUE_APP_URL}/api/v1/transactional-data/transactions`,data);
      }
      return context.$http.post(`${process.env.VUE_APP_URL}/api/v1/transactional-data/transactions`,data);
    },
    getTableData({state, commit},{context, scenario, dimensionId}){
      let order = state.orderField ? `&ordering=${state.orderField}` : ''
      let searchTerm = state.searchTerm.length > 0 ? `&searchTerm=${state.searchTerm}` : ''
      return context.$http.get(
        `${process.env.VUE_APP_URL}/api/v1/transactional-data/transactions?scenario=${scenario}&dimension=${dimensionId}${order}&limit=${state.limit}&offset=${state.offset}${searchTerm}`
        )
        .then(response => {
          commit('SET_TRANSACTIONS', response.data.items);
          commit('SET_TOTAL_TRANSACTIONS', response.data.count);
          return true;
        }).catch((err) => {
            commit("SET_ERROR_ON_LOAD", true)
        });
    },
    getDriversForm({state, commit}, {context, dimensionId}){
      return context.$http.get(
          `${process.env.VUE_APP_URL}/api/v1/transactional-data/drivers?dimension=${dimensionId}`
          )
          .then(response => {
            commit('SET_DRIVERS_FORM', response.data.items);
          return true;
        }).catch((err) => {
          console.log(err);
      });
    },
    getTabelDrivers({state, commit}, {context, dimensionId}){
      let order = state.driversOrderField ? `&ordering=${state.driversOrderField}` : ''
      context.$http.get(
        `${process.env.VUE_APP_URL}/api/v1/transactional-data/drivers?dimension=${dimensionId}${order}&limit=${state.driverLimit}&offset=${state.driverOffset}`
        )
        .then(response => {
          commit('SET_DRIVERS', response.data.items);
          commit("SET_TOTAL_DRIVERS", response.data.count);
        return true;
      }).catch((err) => {
        commit("SET_ERROR_ON_LOAD", true)
    });
    },
    getDriversList({state, commit}, {context, dimensionId}){
        let order = state.driversListOrderField ? `&ordering=${state.driversListOrderField}` : ''
        context.$http.get(
          `${process.env.VUE_APP_URL}/api/v1/transactional-data/drivers?dimension=${dimensionId}${order}&limit=${state.driversListLimit}&offset=${state.driversListOffset}`
          )
          .then(response => {
            commit('SET_DRIVERS_LIST', response.data.items);
            commit("SET_TOTAL_DRIVERS_LIST", response.data.count);
          return true;
        }).catch((err) => {
            commit("SET_ERROR_ON_LOAD", true)
        });
      },
    clearTransactionsData({ commit} ) {
        commit("SET_OFFSET", 0);
        commit("SET_LIMIT", 10);
        commit("SET_TRANSACTIONS", []);
        commit("SET_TOTAL_TRANSACTIONS", 0);
        commit("SET_DRIVERS", []);
        commit("SET_TOTAL_DRIVERS", 0);
        commit("SET_ORDER_FIELD", "");
        commit("SET_DRIVERS_ORDER_FIELD", "");
        commit("SET_DRIVERS_LIST", []);
        commit("SET_TOTAL_DRIVERS_LIST", 0)
        commit("SET_ERROR_ON_LOAD", null)
    }
  }
}
